import React, { useState } from "react";
import "./newslater.css";
import Form from "react-bootstrap/Form";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { postSubscriber } from "../../../features/home/homeSlice";
import Success_Modal from "../../common-components/common-modals/success_modal/Success_Modal";

const Newslater = () => {
  const dispatch = useDispatch();

  // setup form
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [showModal, setShowModal] = useState(false);
  const onSubmit = async (data) => {
    const sendData = { email: data?.email };
    const res = await dispatch(postSubscriber({ data: sendData }));

    if (res.meta?.requestStatus === "fulfilled") {
      setShowModal(true);
      reset(); // clear form
      setTimeout(() => {
        setShowModal(false);
      }, 2000);
    } else if (res.meta?.requestStatus === "rejected") {
      console.log("Subscription failed");
    }
  };

  return (
    <section className="Newslater_section">
      <div className="container">
        <div className="row">
          <div className="col-xl-9 mx-auto">
            <div className="newssec">
              <img
                className="newlatericon"
                src={
                  process.env.PUBLIC_URL +
                  "/assets/images/home/newslater/latter.png"
                }
                alt="newslater-icon"
              />
              <h3 className="subscrititle">SUBSCRIBE TO OUR NEWSLETTER</h3>
              <p className="subscrisubp">
                Subscribe our newsletter to receive the latest news and
                exclusive offers every week
              </p>

              {/* form start */}
              <Form onSubmit={handleSubmit(onSubmit)}>
                <div className="subinpudiv">
                  <Form.Control
                    type="email"
                    placeholder="Enter your email address here"
                    {...register("email", {
                      required: "Email is required",
                      pattern: {
                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                        message: "Enter a valid email",
                      },
                    })}
                  />
                  <button type="submit" className="subscribe-btn">
                    <span>Subscribe</span>
                  </button>
                </div>
                {errors?.email && (
                  <sup className="text-danger">{errors.email.message}</sup>
                )}
              </Form>
              {/* form end */}
            </div>
          </div>
        </div>
      </div>
        <Success_Modal
        show={showModal}
        successText={"Subscribed successfully!"}
        onHide={() => setShowModal(false)}
      />
    </section>
  );
};

export default Newslater;
